<script setup>
import { defineProps } from "vue"
import { Gems } from "@/gems"
import RatingScale from "../RatingScale.vue"
import { useValidationListView } from '@/composables/useValidationListView'
import BaseSelect from "../BaseSelect.vue";
import TransferRows from "../TransferRows.vue";

const props = defineProps({
  validateData: {
    type: Object,
    default: Object
  },
  
  ratingSkillsModal: {
    type: Object,
    default: Object
  },

  ratingData: {
    type: Object,
    default: Object
  },

  validationWithCertification: {
    type: Boolean,
    default: false
  }
})

const {
  userStore,
  ratingType,
  userFilter,
  requestDateAsc,
  VALIDATION_LABEL,
  getHistory,
  openHistoryItemModal,
  validateHistoryItem,
  canPostValidation,
  showOnlySelf
} = useValidationListView({
  validateData: props.validateData,
  ratingSkillsModal: props.ratingSkillsModal,
})

</script>

<template>
  <div class="div-validate-list">

    <div class="div-admin-filter">

      <input class="col-3" type="text" name="userFilter" id="userFilter" v-model="userFilter" placeholder="Procurar...">

      <div class="div-radios" v-if="!props.validateData.validationToTransfer.value">
        <div>
          <input class="cursor-pointer" type="radio" value="2" v-model="ratingType" @change="props.validateData.RequestValidationList()"/>
          <label for="">Em aberto</label>
        </div>
        
        <div>
          <input class="cursor-pointer" type="radio" value="1" v-model="ratingType" @change="props.validateData.RequestValidationList()"/>
          <label for="">Publicados</label>
        </div>
        
        <div>
          <input class="cursor-pointer" type="radio" value="3" v-model="ratingType" @change="props.validateData.RequestValidationList()"/>
          <label for="">Todos</label>
        </div>
      </div>

      <div class="cursor-pointer div-admin-sort" @click="props.validateData.ToggleRequestDateSort(requestDateAsc = !requestDateAsc)">
        <i class="fs-4 bi" :class="{'bi-sort-numeric-up': !requestDateAsc ,'bi-sort-numeric-down': requestDateAsc}" />
        <label class="cursor-pointer">Ordenar por data do pedido</label>
      </div>

      <div class="div-admin-sort" v-if="!props.validateData.validationToTransfer.value">
        <input class="chk cursor-pointer" type="checkbox" v-model="showOnlySelf" @change="props.validateData.RequestValidationList()"/>
        <label for="">Somente os meus pedidos</label>
      </div>
    </div>
      
    <div v-if="props.validateData.filteredValidationList.value.length == 0 && !props.validateData.showUserRequests.value" class="div-empty-list">
      <span v-if="props.validateData.validationToTransfer.value"> Sem pedidos de transferência </span>
      <span v-else>Sem resultados [{{ratingType == 1 ? 'Publicados' : ratingType == ratingType == 2 ? 'Em aberto' : 'Todos'}}]</span>
    </div>

    <div v-else-if="props.validateData.validationList.value.length >= 0 && !props.validateData.showUserRequests.value">
      <div class="list-teams list-header">
        <span class="text-start">Equipa(s)</span>
        <span>Nº Utilizadores</span>
        <span>{{ratingType == 1 ? 'Publicados' : ratingType == 2 ? 'Em aberto' : 'Todos'}}</span>
        <span>Novas Mensagens</span>
        <span class="cursor-pointer" @click="props.validateData.ToggleAllTeams()">{{props.validateData.toggleAllTeams.value ? 'Fechar' : 'Expandir'}} todos</span>
      </div>

      <div class="div-teams-container" :class="{'bg-alt-line': i % 2 == 0, 'div-history-frame': team.showDetail}" v-for="(team, i) in props.validateData.filteredValidationList.value" :key="i">
        <div class="list-teams">
          <span class="text-start">{{ team.designation }}</span>

          <span>{{ ratingType != 3 ? team[`rating_${ratingType}_user_count`] : team[`rating_1_user_count`] + team[`rating_2_user_count`] }}</span>
        
          <span>{{ ratingType != 3 ? team[`rating_${ratingType}_count`] : team[`rating_1_count`] + team[`rating_2_count`] }}</span>

          <span>
            <i v-if="team[`new_messages_count_${ratingType}`] > 0" class="fas icon-size fa-envelope"></i>
          </span>

          <i class="bi bi-chevron-down cursor-pointer" :class="{'bi-chevron-up': team.showDetail}" @click="props.validateData.TeamDetail(team)"></i>
        </div>

        <div v-show="team.showDetail">
          <div v-for="(user, ui) in team.users" :key="ui" v-show="!user.hide">
            <div class="list-users">
              <span></span>

              <span class="text-start">{{ user.name }}</span>
            
              <span></span>

              <span>{{ ratingType != 3 ? user[`rating_${ratingType}_count`] : user[`rating_1_count`] + user[`rating_2_count`] }}</span>
              
              <span>
                <i v-if="user[`new_messages_count_${ratingType}`] > 0" class="fas icon-size fa-envelope"></i>
              </span>
              <i class="bi bi-arrow-return-right cursor-pointer" @click="props.validateData.ShowUserRequests(user)"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else-if="props.validateData.validationList.value.length >= 0 && props.validateData.showUserRequests.value">
      <div class="div-user-sitemap">
        <span @click="props.validateData.BackToTeams()" class="fw-bold cursor-pointer">Equipas</span>
        <i class="bi bi-arrow-right"></i>
        <span>{{ props.validateData.userSelected.value.team_designation }}</span>
        <i class="bi bi-arrow-right"></i>
        <span>{{ props.validateData.userSelected.value.name }}</span>
      </div>

      <div v-if="(props.validateData.displayedRequests.value || []).length === 0" class="div-empty-list">
        <span> Sem {{ props.validateData.validationToTransfer.value ? 'pedidos de transferência' : 'validações'}} para o utilizador selecionado</span>
      </div>

      <div v-else-if="props.validateData.validationToTransfer.value">
        <TransferRows :validate-data="props.validateData" :validation-list="props.validateData.displayedRequests.value" :rating-data="props.ratingData" :rating-skills-modal="props.ratingSkillsModal"/>
      </div>

      <div v-else>
        <div class="list-item list-header">
          <span>Data pedido</span>
          <span class="span-elem">Descrição</span>
          <span>Classificação</span>
          <span>Validador</span>
          <span>Validação</span>
          <span>Data validação</span>
          <span></span>
        </div>
  
        <div class="div-row-frame" :class="{'div-history-frame': elem.showOtherValidators}" v-for="(elem, i) in props.validateData.displayedRequests.value" :key="elem.id">
          <div class="list-item" :class="{'bg-alt-line': i % 2 == 0, 'div-to-validate': elem.validation_date == null && ratingType ==3}">            
            <span class="d-flex justify-content-center">
              <div class="align-content-center">
                <i class="fas fa-chevron-down cursor-pointer" @click="getHistory(elem)" v-if="elem.has_more && (elem.rating_type == 2 && userStore.User?.permissions?.is_admin)"></i>
                <div class="div-without-history" v-else></div>
              </div>
              
              <div class="div-request-date">{{ elem.request_date }}</div>
            </span>
    
            <span class="span-elem line-clamp line-clamp-1">
              <i v-if="!elem.is_op_skill" class="fa-solid fa-copyright me-1" @mouseover="Gems.Tooltip($event.target, 'Conhecimento', 'tooltip')"></i>
              <span @mouseenter="Gems.Tooltip($event.target, elem.sitemap, 'tooltip tooltip-left')">
                {{ elem.designation }}
              </span>
            </span>
            
            <span class="radios">
              <RatingScale :rating-data="props.ratingData" :element="elem" :mobile-view="false" :validate-skills="true"/>
            </span>

            <span class="line-clamp line-clamp-1" @mouseenter="Gems.TooltipIfNeeded($event.target)">
              {{ elem.validator_name }}
            </span>
    
            <span class="line-clamp line-clamp-1">
              {{ VALIDATION_LABEL[elem.validation] }}
            </span>
    
            <span>
              {{ elem.validation_date }}
            </span>
    
            <div class="modal-icon">
              <i class="fas fa-eye cursor-pointer" :class="{'eye-notification': elem.has_files_not_viewed }" @click="props.ratingSkillsModal.OpenModalDocs(elem)" @mouseenter="Gems.Tooltip($event.target, 'Detalhes', 'tooltip')"></i>
              <i class="fas fa-envelope" v-if="elem.has_unread_messages_only_validators || elem.has_unread_messages" @mouseenter="Gems.Tooltip($event.target, 'Tens novas mensagens', 'tooltip')"></i>
            </div>
            
            <div class="div-btn">
              <button class="ddl-alt-padding" v-if="elem.newValidatorId" @click="props.validateData.ChangeValidator(elem)">TRANSFERIR</button>
              <button class="ddl-alt-padding" v-else-if="canPostValidation(elem)" @click="props.validateData.Validate(elem)">PUBLICAR</button>
            </div>
          </div>

          <div v-if="elem.showOtherValidators">
            
            <div class="list-item" v-for="(reqValidation, hi) in elem.otherValidators" :key="hi">
              <div class="div-request-date-history">{{ reqValidation.request_date }}</div>
      
              <span class="span-elem line-clamp line-clamp-1" @mouseenter="Gems.Tooltip($event.target, elem.sitemap, 'tooltip tooltip-left')">
                {{ reqValidation.designation }}
              </span>
              
              <span class="radios">
                <RatingScale :rating-data="props.ratingData" :element="reqValidation" :mobile-view="false" :validate-skills="true"/>
              </span>

              <span @mouseenter="Gems.TooltipIfNeeded($event.target)">
                <base-select v-model="reqValidation.selectedValidatorId" v-if="reqValidation.validators_count > 1">
                  <option value="">Escolha um validador...</option>
                  <option v-for="(validator, vi) in reqValidation.validators" :value="validator.validator_id" :key="vi">{{ validator.validator_name}}</option>
                </base-select>

                <span class="line-clamp line-clamp-1" v-else>
                  {{ reqValidation.validators[reqValidation.selectedValidatorId]?.validator_name }}
                </span>
              </span>
              <span class="line-clamp line-clamp-1">
                <div v-if="reqValidation.selectedValidatorId">{{ VALIDATION_LABEL[reqValidation.validators[reqValidation.selectedValidatorId]?.validation]}}</div>
              </span>
      
              <span>{{ reqValidation?.validators[reqValidation?.selectedValidatorId]?.validation_date }}</span>

              <div class="modal-icon" v-if="reqValidation.selectedValidatorId">
                <i class="fas fa-eye cursor-pointer" @click="openHistoryItemModal(reqValidation)" @mouseenter="Gems.Tooltip($event.target, 'Detalhes', 'tooltip')"></i>
              </div>
              
              <div class="div-btn" v-if="canPostValidation(reqValidation.validators[reqValidation.selectedValidatorId])">
                <button class="ddl-alt-padding" @click="validateHistoryItem(reqValidation)">PUBLICAR</button>
              </div>
            </div>
          </div>
        </div>
        
      </div>
    </div> 
  </div>
</template>

<style scoped>
@import '../assets/styles/validate-skills.css';

.modal-icon {
  font-size: 1.1em;
}

.fa-envelope { 
  position: relative;
  left: 0px;
  top: -9px;
  font-size: 0.7em !important;
  width: 0px;
}

.icon-size {
  font-size: 12pt !important;
  position: unset;
  width: auto;
}


.list-item select {
  width: 100%;
  font-size: .9em;
  background-color: transparent;
  text-align: center;
}

.div-btn button {
  width: 100% !important;
}

.list-teams {
  grid-template-columns: 30% 20% 20% 20% 9.4%;
}

.list-users {
  grid-template-columns: 2% 28% 20% 20% 20% 9%;
}

.list-item {
  border-left: 4px solid transparent;
  grid-template-columns: 10% 20% 20% 10% 10% 10% 9% 9%;
}

.list-item,
.list-teams,
.list-users {
  display: grid;
  text-align: center;
  align-items: center;
  gap: .2%;
  padding: 5px;
  margin-bottom: 1px;
  min-height: 40px;
}

.list-header {
  font-weight: bold;
}

.span-claimant,
.span-elem {
  text-align: left;
  cursor: default;
}

.input-small-padding {
  padding: 7px 10px !important;
}

.div-admin-filter {
  display: flex;
  gap: 50px;
}

.div-admin-sort {
  display: flex; 
  gap: 10px;
  align-items: center; 
}

.div-radios div {
  gap: 10px; 
}

.div-radios div input {
  transform: scale(1.3);
}

.div-user-sitemap {
  display: flex;
  gap: 5px;
  padding: 10px 0px;
}

.radios {
  display: flex;
  font-size: 1.2em;
  justify-content: center;
}

.div-row-frame,
.div-teams-container {
  border: 2px solid transparent;
}

.div-history-frame {
  border: 2px solid;
  margin-bottom: 2px;
}

.div-request-date {
  flex: 2;
}

.div-request-date-history {
  margin-left: 12px;
}

.div-without-history {
  width: 12px;
}
 
@media screen and (max-width: 700px) {
  .list-item,
  .div-admin-filter {
    font-size: .85em;
  }

  .div-admin-filter {
    gap: 5px;
  }
}

@media screen and (max-width: 1200px) {
  .list-item {
    grid-template-columns: 12% 13% 21% 12% 12% 12% 3% 13%;
  }

  .div-btn button {
    width: unset !important;
  }

  .radios {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    row-gap: 3px;
  }

  .radios input {
    transform: scale(1) !important;
    margin-top: 0px;
  }

  .radios div {
    padding: 1px;
  }
}
</style>